module.exports = __webpack_public_path__ + "static/media/sound-bubble-play.e81708f2.png";